import type { CheckoutConfig } from '#types/config/pages/checkout'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    itemSelected: '!b-brand-2/30 bg-brand-5',
    legalCheckbox: 'text-center body-4 c-black mt-4'
  },
  legalCheckboxStep: 'payment',
  contactFieldsOrder: (() => ['phone', 'email']) as unknown as CheckoutConfig['contactFieldsOrder']
} satisfies RecursivePartial<CheckoutConfig>
